module.exports = __webpack_public_path__ + "static/img/car_15_16_5_cold@3x.0a18a054.png";